import {createAction} from '@reduxjs/toolkit';

// Quick Focused Items are meant to complement Focused Items. As the name implies,
// the difference is that these should be quickly, and temporarily, applied. At time
// of implementation, this is meant to be used for showing item footprints when the
// footprint button is hovered, without conflicting with the main Focused Items

const PREFIX = 'items';

export const quickFocusItems = createAction(`${PREFIX}/quick-focus`);
export const quickUnfocusAllItems = createAction(`${PREFIX}/quick-unfocusAll`);
